import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextComponent } from './components/input-text/input-text.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputIconComponent } from './components/input-icon/input-icon.component';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { InputMultiSelectComponent } from './components/input-multi-select/input-multi-select.component';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from '../button/button.module';
import { UploadComponent } from './components/upload/upload.component';
import { InputTextareaComponent } from './components/input-textarea/input-textarea.component';
import { TextareaModule } from 'primeng/textarea';
import { HelperTextComponent } from './components/base/helper-text.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@NgModule({
  declarations: [
    InputTextComponent,
    InputIconComponent,
    CheckboxComponent,
    InputMultiSelectComponent,
    UploadComponent,
    InputTextareaComponent,
    HelperTextComponent,
    ToggleSwitchComponent,
  ],
  imports: [
    CommonModule,
    InputTextModule,
    FloatLabelModule,
    ReactiveFormsModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
    CheckboxModule,
    MultiSelectModule,
    FileUploadModule,
    ButtonModule,
    TextareaModule,
    ToggleSwitchModule,
  ],
  exports: [
    InputTextComponent,
    InputIconComponent,
    CheckboxComponent,
    InputMultiSelectComponent,
    UploadComponent,
    InputTextareaComponent,
    HelperTextComponent,
    ToggleSwitchComponent,
  ],
})
export class InputModule {}
